// extracted by mini-css-extract-plugin
module.exports = {"title":"FolderLink_title__tRji4","clickable":"FolderLink_clickable__2WekD"};